/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DatePicker from 'react-datepicker';
import { setLoader, setSelectedPeriod, setSelectedCustomPeriod } from '../../redux/reducer';
import i18next from '../../translations/i18n';
import utils from '../../services/Utils';

import 'react-datepicker/dist/react-datepicker.css';

const DATE_FORMAT_DD_MM_YYYY = 'dd/MM/yyyy';
const formatYMD = d =>
  d
    ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    : null;

const PeriodSelector = () => {
  const dispatch = useDispatch();

  const {
    timePeriods,
    selectedPeriod = '',
    firstStartDate,
    lastEndDate,
    selectedPeriodFilteredData,
  } = useSelector(state => state.app);

  const [calenderStartDate, setStartDate] = useState(new Date());
  const [calenderEndDate, setEndDate] = useState(new Date());

  useEffect(() => {
    dispatch(setLoader(false));
    const [firstDate, latestDate] = utils.getFirstAndLastDates(selectedPeriodFilteredData);
    setStartDate(firstDate);
    setEndDate(latestDate);
  }, [selectedPeriod, selectedPeriodFilteredData]);

  return (
    <div className="period-selector">
      <div className="row reverted-row pb-5 pb-xs-0">
        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
          <div className="am-btn-filters-date d-flex-wrap-custom pl-8-custom pb-xs-4">
            {timePeriods.map(label => {
              if (label !== 'CUSTOM') {
                return (
                  <button
                    key={label}
                    type="button"
                    className={`btn-timeseries bg-white font-size-14 text-uppercase border-none ${selectedPeriod === label ? 'active' : ''}`}
                    onClick={() => dispatch(setSelectedPeriod(label))}
                  >
                    {' '}
                    {i18next.t(label)}
                  </button>
                );
              }
              return null;
            })}
          </div>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div className="wt-charts-date row pb-xs-4 pt-xs-2">
            <div className="wt-charts-input pr-5">
              <label className="date-label font-size-14">{i18next.t('FROM')}</label>
              <DatePicker
                selected={calenderStartDate}
                onChange={date => {
                  setStartDate(date);
                  const range = [formatYMD(date), formatYMD(calenderEndDate)];
                  if (date) {
                    dispatch(setSelectedCustomPeriod({ period: 'CUSTOM', range }));
                  }
                }}
                showYearDropdown
                showMonthDropdown
                className="date-picker font-size-14"
                minDate={firstStartDate}
                maxDate={lastEndDate}
                calendarClassName="custom-calendar"
                wrapperClassName="datePicker"
                dateFormat={DATE_FORMAT_DD_MM_YYYY}
                placeholderText={i18next.t('FROM')}
                enableTabLoop={false}
                scrollableYearDropdown
              />
            </div>
            <div className="wt-charts-input pr-5">
              <label className="date-label font-size-14">{i18next.t('TO')}</label>
              <DatePicker
                selected={calenderEndDate}
                onChange={date => {
                  setEndDate(date);
                  const range = [formatYMD(calenderStartDate), formatYMD(date)];
                  if (date) {
                    dispatch(setSelectedCustomPeriod({ period: 'CUSTOM', range }));
                  }
                }}
                showYearDropdown
                showMonthDropdown
                className="date-picker font-size-14"
                minDate={calenderStartDate}
                maxDate={lastEndDate}
                dateFormat={DATE_FORMAT_DD_MM_YYYY}
                placeholderText={i18next.t('TO')}
                enableTabLoop={false}
                scrollableYearDropdown
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeriodSelector;
